module.exports = __webpack_public_path__ + "img/SUPEROK_10.21089f0e.jpeg";